import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.css';

type Props = {
  readonly value: string;
  readonly placeholder: string;
  readonly onChange: (input: string) => void;
  readonly onKeyDown?: (
    event: React.KeyboardEvent<HTMLTextAreaElement>,
  ) => void;
};

export const TextInput: React.FC<Props> = props => {
  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ): void => {
    props.onChange(event.currentTarget.value);
  };

  return (
    <div className={clsx(styles.container)}>
      <textarea
        placeholder={props.placeholder}
        className={styles.input}
        value={props.value}
        onChange={handleChange}
        onKeyDown={props.onKeyDown}
      />
    </div>
  );
};
